//jQuery_T4NT(document).ready(function($) {

/**
 *  Variant selection changed
 *  data-variant-toggle="{{variant.id}}"
 */
//$( document ).on( "variant:changed", function( evt ) {
// console.log( evt.currentVariant );
// $('[data-variant-toggle]').hide(0);
// $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
//});

//});
/*
document.addEventListener('DOMContentLoaded', function() {
  // Function to hide sold-out products
  function hideSoldOutProducts() {
    var products = document.querySelectorAll('.t4s-product');
    products.forEach(function(product) {
      if (product.classList.contains('available-false')) {
        product.style.display = 'none';
      }
    });
  }

  // Run the function on page load
  hideSoldOutProducts();

  // Re-run the function after filters are applied
  document.addEventListener('facets:loaded', function() {
    hideSoldOutProducts();
  });

  // Assuming your filters trigger a custom event 'filters:updated'
  document.addEventListener('facets:updated', function() {
    hideSoldOutProducts();
  });

  document.addEventListener('facet:loaded', function() {
        alert();
      });

  document.querySelectorAll('.t4s-filter__values li').forEach(function(checkbox) {
  checkbox.addEventListener('click', function(event) {
    console.log('Checkbox clicked:', event);
  });
});

});
*/

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".t4s-filter__values li a")
    .forEach(function (checkbox) {
      checkbox.addEventListener("click", function (event) {
        event.preventDefault();
        alert();
        console.log("Checkbox clicked:", event);
      });
    });
  document.addEventListener("facets:loaded", function () {
    alert();
  });
});
